import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import axios from "axios";

import Nav from '../../common/components/Nav';
import Footer from '../../common/components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { errorHandler } from "../../utils/helpers/errorHandler";

const baseUrl = `${process.env.REACT_APP_BASE_URL}`;

const SubmitDatasetPage = () => {
  const history = useHistory();
  
  const [description, setDescription] = useState('');
  const [datasetName, setDatasetName] = useState('');
  const [file, setFile] = useState(null);
  const [datasetType, setDatasetType] = useState("file");
  const [title, setTitle] = useState("");
  const [consent, setConsent] = useState(false);
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");

  const [showLoader, setLoader] = useState(false);

  const handleUploadDataset = async (event) => {
    event.preventDefault();
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', datasetName);
      formData.append('description', description);
      formData.append('title', title);
      formData.append('email', email);
      formData.append('consent', consent);
      formData.append('type', datasetType);
      formData.append('fullName', fullName);

      const { data: dataset } = await axios(`${baseUrl}/datasets/public`, {
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setDescription('');
      setDatasetName('');
      setFile(null);
      setDatasetType("file");
      setTitle("");
      setConsent(false);
      setEmail("");
      setFullName("");
      setLoader(false);

      setTimeout(() => {
        toast.success(`${dataset.message}`);
      }, 500);

      history.push("/");

    } catch (error) {
      setLoader(false);
      errorHandler(error.response ? error.response.data : error, toast);
    }
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        backgroundColor: "#F8FAFC",
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif"
      }}
    >
      {/* Page Header */}
      <header className="bg-white border-bottom border-light">
        <Nav />
        <div className="py-5" style={{ backgroundColor: "#F1F5F9" }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <span
                  className="badge rounded-pill px-3 py-2 text-uppercase mb-3 fw-semibold"
                  style={{
                    backgroundColor: "rgba(10, 61, 46, 0.08)",
                    color: "#0A3D2E",
                    fontSize: "12px",
                    letterSpacing: "0.8px",
                  }}
                >
                  Public Contribution
                </span>
                <h1 className="fw-bold text-dark display-6 mb-3" style={{ letterSpacing: "-0.5px" }}>
                  Upload Dataset
                </h1>
                <p className="text-secondary fs-6 lh-relaxed mb-0">
                  Do you have datasets you would like to share with the public? Please fill out the form below to submit the dataset which will be reviewed before being made available to the public.
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Form Section */}
      <section className="flex-grow-1 py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9">
              <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm border">
                
                <form onSubmit={handleUploadDataset}>
                  
                  {/* Full Name */}
                  <div className="mb-4">
                    <label className="form-label fw-medium text-dark small mb-1">
                      Your Full Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control px-3 py-2 rounded-3 border-light-subtle shadow-none"
                      placeholder="Your Full Name"
                      value={fullName}
                      onChange={event => setFullName(event.target.value)}
                      required
                    />
                  </div>

                  {/* Dataset Name */}
                  <div className="mb-4">
                    <label className="form-label fw-medium text-dark small mb-1">
                      Dataset Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control px-3 py-2 rounded-3 border-light-subtle shadow-none"
                      placeholder="Dataset Name"
                      value={datasetName}
                      onChange={event => setDatasetName(event.target.value)}
                      required
                    />
                  </div>

                  {/* Dataset File */}
                  <div className="mb-4">
                    <label className="form-label fw-medium text-dark small mb-1">
                      Dataset File <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control px-3 py-2 rounded-3 border-light-subtle shadow-none"
                      onChange={event => setFile(event.target.files[0])}
                      required
                    />
                  </div>

                  {/* Description */}
                  <div className="mb-4">
                    <label className="form-label fw-medium text-dark small mb-1">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control px-3 py-2 rounded-3 border-light-subtle shadow-none"
                      rows="7"
                      placeholder="Description"
                      value={description}
                      onChange={event => setDescription(event.target.value)}
                      required
                    ></textarea>
                  </div>

                  {/* Title */}
                  <div className="mb-4">
                    <label className="form-label fw-medium text-dark small mb-1">
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control px-3 py-2 rounded-3 border-light-subtle shadow-none"
                      placeholder="Title"
                      value={title}
                      onChange={event => setTitle(event.target.value)}
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-4">
                    <label className="form-label fw-medium text-dark small mb-1">
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control px-3 py-2 rounded-3 border-light-subtle shadow-none"
                      placeholder="Email"
                      value={email}
                      onChange={event => setEmail(event.target.value)}
                      required
                    />
                  </div>

                  {/* Consent & License Checkbox */}
                  <div className="p-3 mb-4 rounded-3 border bg-light">
                    <div className="form-check d-flex align-items-start gap-2">
                      <input
                        type="checkbox"
                        id="consent"
                        className="form-check-input mt-1 cursor-pointer"
                        checked={consent === true}
                        onChange={(event) => setConsent(event.target.checked)}
                        style={{ width: "16px", height: "16px", cursor: "pointer" }}
                      />
                      <label htmlFor="consent" className="form-check-label text-secondary small lh-sm cursor-pointer mb-0">
                        I confirm that all the information that I have provided is genuine and valid.{" "}
                        <a
                          href="https://creativecommons.org/licenses/by/4.0/"
                          className="fw-semibold text-decoration-none"
                          style={{ color: "#0A3D2E" }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          License: CC BY 4.0
                        </a>
                      </label>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="btn w-100 rounded-pill py-3 text-white fw-medium shadow-sm transition-all d-flex align-items-center justify-content-center gap-2"
                    style={{
                      backgroundColor: consent ? "#0A3D2E" : "#94A3B8",
                      borderColor: "transparent",
                      cursor: consent ? "pointer" : "not-allowed",
                    }}
                    disabled={!consent || showLoader}
                  >
                    <span>Send</span>
                    {showLoader && (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    )}
                  </button>

                </form>

              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer closeOnClick pauseOnHover />
      <Footer />
    </div>
  );
};

export default SubmitDatasetPage;